import { useQuery } from '@tanstack/react-query';

import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { hasKey } from '~/utils';
import { GradeSchemaInfo } from '~/types/gradeConversion';
import { GradeSchemaResource, ListGradeSchemasResponse } from '@ab/ams-school-api/types/private/v1';

export function useGradeSchemas() {
  const request = useRequest();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['gradeSchemas'],
    queryFn: async () => {
      const response = await request<ListGradeSchemasResponse>(
        `${config.apiHost}/private/v1/grade_schemas?page[number]=1&page[size]=100`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const schemas: GradeSchemaInfo[] = response.data.map(mapGradeSchemaResource);
      return schemas;
    },
  });

  return {
    gradeSchemas: data ?? [],
    isLoadingGradeSchemas: isLoading,
    isGradeSchemasError: isError,
    gradeSchemasError: error,
  };
}

function isExpectedResponse(res: unknown): res is ListGradeSchemasResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}

function mapGradeSchemaResource(resource: GradeSchemaResource): GradeSchemaInfo {
  return {
    id: resource.id,
    name: resource.attributes.name,
    gradeSchemaType: resource.attributes.gradeSchemaType,
    minGrade: resource.attributes.minGrade,
    maxGrade: resource.attributes.maxGrade,
    validGrades: resource.attributes.validGrades,
  };
}
